"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { ApiDropType } from "@/generated/models/ApiDropType";
import type { Drop as DropType, ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DropSize } from "@/helpers/waves/drop.helpers";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import { useMemo } from "react";
import DropContext from "./DropContext";
import type { DropIdentityMode, DropInteractionParams, DropLocation, DropTimestampLayout } from "./drop.types";
import ParticipationDrop from "./participation/ParticipationDrop";
import WaveDrop from "./WaveDrop";
import WinnerDrop from "./winner/WinnerDrop";
export type { DropInteractionParams } from "./drop.types";
export { DropLocation } from "./drop.types";
interface DropProps {
  readonly drop: ExtendedDrop;
  readonly previousDrop: DropType | null;
  readonly nextDrop: DropType | null;
  readonly showWaveInfo: boolean;
  readonly activeDrop: ActiveDropState | null;
  readonly showReplyAndQuote: boolean;
  readonly location: DropLocation;
  readonly dropViewDropId: string | null;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onReplyClick: (serialNo: number) => void;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
  readonly parentContainerRef?: React.RefObject<HTMLElement | null> | undefined;
  readonly wrapContentOnly?: (content: React.ReactNode) => React.ReactNode;
  readonly footer?: React.ReactNode;
  readonly identityMode?: DropIdentityMode | undefined;
  readonly timestampLayout?: DropTimestampLayout | undefined;
  readonly showInteractions?: boolean | undefined;
}
export default function Drop(t0) {
  const $ = _c(60);
  const {
    drop,
    previousDrop,
    nextDrop,
    showWaveInfo,
    activeDrop,
    location,
    dropViewDropId,
    onReply,
    onReplyClick,
    onQuoteClick,
    onDropContentClick,
    showReplyAndQuote,
    parentContainerRef,
    wrapContentOnly,
    footer,
    identityMode,
    timestampLayout,
    showInteractions: t1
  } = t0;
  const showInteractions = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== activeDrop || $[1] !== drop || $[2] !== footer || $[3] !== identityMode || $[4] !== location || $[5] !== onDropContentClick || $[6] !== onQuoteClick || $[7] !== onReply || $[8] !== parentContainerRef || $[9] !== showInteractions || $[10] !== showReplyAndQuote || $[11] !== showWaveInfo || $[12] !== timestampLayout) {
    t2 = <ParticipationDrop drop={drop} showWaveInfo={showWaveInfo} activeDrop={activeDrop} location={location} onReply={onReply} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} showReplyAndQuote={showReplyAndQuote} parentContainerRef={parentContainerRef} footer={footer} identityMode={identityMode} timestampLayout={timestampLayout} showInteractions={showInteractions} />;
    $[0] = activeDrop;
    $[1] = drop;
    $[2] = footer;
    $[3] = identityMode;
    $[4] = location;
    $[5] = onDropContentClick;
    $[6] = onQuoteClick;
    $[7] = onReply;
    $[8] = parentContainerRef;
    $[9] = showInteractions;
    $[10] = showReplyAndQuote;
    $[11] = showWaveInfo;
    $[12] = timestampLayout;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== activeDrop || $[15] !== drop || $[16] !== dropViewDropId || $[17] !== footer || $[18] !== identityMode || $[19] !== location || $[20] !== nextDrop || $[21] !== onDropContentClick || $[22] !== onQuoteClick || $[23] !== onReply || $[24] !== onReplyClick || $[25] !== parentContainerRef || $[26] !== previousDrop || $[27] !== showInteractions || $[28] !== showReplyAndQuote || $[29] !== showWaveInfo || $[30] !== timestampLayout) {
    t3 = <WinnerDrop drop={drop} previousDrop={previousDrop} nextDrop={nextDrop} showWaveInfo={showWaveInfo} activeDrop={activeDrop} location={location} dropViewDropId={dropViewDropId} onReply={onReply} onReplyClick={onReplyClick} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} showReplyAndQuote={showReplyAndQuote} parentContainerRef={parentContainerRef} footer={footer} identityMode={identityMode} timestampLayout={timestampLayout} showInteractions={showInteractions} />;
    $[14] = activeDrop;
    $[15] = drop;
    $[16] = dropViewDropId;
    $[17] = footer;
    $[18] = identityMode;
    $[19] = location;
    $[20] = nextDrop;
    $[21] = onDropContentClick;
    $[22] = onQuoteClick;
    $[23] = onReply;
    $[24] = onReplyClick;
    $[25] = parentContainerRef;
    $[26] = previousDrop;
    $[27] = showInteractions;
    $[28] = showReplyAndQuote;
    $[29] = showWaveInfo;
    $[30] = timestampLayout;
    $[31] = t3;
  } else {
    t3 = $[31];
  }
  const t4 = previousDrop?.type === DropSize.FULL ? previousDrop : null;
  const t5 = nextDrop?.type === DropSize.FULL ? nextDrop : null;
  let t6;
  if ($[32] !== activeDrop || $[33] !== drop || $[34] !== dropViewDropId || $[35] !== footer || $[36] !== identityMode || $[37] !== location || $[38] !== onDropContentClick || $[39] !== onQuoteClick || $[40] !== onReply || $[41] !== onReplyClick || $[42] !== showInteractions || $[43] !== showReplyAndQuote || $[44] !== showWaveInfo || $[45] !== t4 || $[46] !== t5 || $[47] !== timestampLayout || $[48] !== wrapContentOnly) {
    t6 = <WaveDrop drop={drop} previousDrop={t4} nextDrop={t5} showWaveInfo={showWaveInfo} activeDrop={activeDrop} location={location} dropViewDropId={dropViewDropId} onReply={onReply} onReplyClick={onReplyClick} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} showReplyAndQuote={showReplyAndQuote} wrapContentOnly={wrapContentOnly} footer={footer} identityMode={identityMode} timestampLayout={timestampLayout} showInteractions={showInteractions} />;
    $[32] = activeDrop;
    $[33] = drop;
    $[34] = dropViewDropId;
    $[35] = footer;
    $[36] = identityMode;
    $[37] = location;
    $[38] = onDropContentClick;
    $[39] = onQuoteClick;
    $[40] = onReply;
    $[41] = onReplyClick;
    $[42] = showInteractions;
    $[43] = showReplyAndQuote;
    $[44] = showWaveInfo;
    $[45] = t4;
    $[46] = t5;
    $[47] = timestampLayout;
    $[48] = wrapContentOnly;
    $[49] = t6;
  } else {
    t6 = $[49];
  }
  let t7;
  if ($[50] !== t2 || $[51] !== t3 || $[52] !== t6) {
    t7 = {
      [ApiDropType.Participatory]: t2,
      [ApiDropType.Winner]: t3,
      [ApiDropType.Chat]: t6
    };
    $[50] = t2;
    $[51] = t3;
    $[52] = t6;
    $[53] = t7;
  } else {
    t7 = $[53];
  }
  const components = t7;
  let t8;
  if ($[54] !== drop || $[55] !== location) {
    t8 = {
      drop,
      location
    };
    $[54] = drop;
    $[55] = location;
    $[56] = t8;
  } else {
    t8 = $[56];
  }
  const memoizedValue = t8;
  const t9 = components[drop.drop_type];
  let t10;
  if ($[57] !== memoizedValue || $[58] !== t9) {
    t10 = <DropContext.Provider value={memoizedValue}>{t9}</DropContext.Provider>;
    $[57] = memoizedValue;
    $[58] = t9;
    $[59] = t10;
  } else {
    t10 = $[59];
  }
  return t10;
}